import React, { useState, useEffect } from 'react';
import OrganizationsList from './OrganizationsList';
import { getAgenturenByOrganization } from '../../../api';
import NotificationBell from '../../common/NotificationBell';


function DesktopNavigation({
  activeSection,
  onSectionChange,
  onLogout,
  user,
  isAdmin,
  isTeamlead,
  isOrgLeader,
  isCallcenterLeader,
  isCallcenterMitarbeiter,
  isFachberater,
  isAgenturLeader,
  leadCounts,
  openSettingsPanel,
  handleCustomerFilter,
  handleTeamDashboard,
  handleViewOrganizationLeads,
  onOpenOrganizationManagement,
  onOpenMembersManagement,
  onViewTeamLeads,
  navigate
}) {
  const [customerDropdownOpen, setCustomerDropdownOpen] = useState(false);
  const [teamDropdownOpen, setTeamDropdownOpen] = useState(false);
  const [orgDropdownOpen, setOrgDropdownOpen] = useState(false);
  const [logoError, setLogoError] = useState(false);
  const [agenturenDropdownOpen, setAgenturenDropdownOpen] = useState(false);
  const [agenturen, setAgenturen] = useState([]); // NEU
  const [agenturenLoading, setAgenturenLoading] = useState(false); // NEU
  const [selectedAgenturId, setSelectedAgenturId] = useState(null); // NEU für Untermenü
  // Fehlerstatus für Agenturen
  const [agenturenFehler, setAgenturenFehler] = useState(null);

  // Dropdown schließen wenn außerhalb geklickt wird
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (customerDropdownOpen && !event.target.closest('.customer-dropdown-container')) {
        setCustomerDropdownOpen(false);
      }
      if (teamDropdownOpen && !event.target.closest('.team-dropdown-container')) {
        setTeamDropdownOpen(false);
      }
      if (orgDropdownOpen && !event.target.closest('.org-dropdown-container')) {
        setOrgDropdownOpen(false);
      }
      if (agenturenDropdownOpen && !event.target.closest('.agenturen-dropdown-container')) {
        setAgenturenDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [customerDropdownOpen, teamDropdownOpen, orgDropdownOpen, agenturenDropdownOpen]);

  // Agenturen laden, wenn Org-Leader ODER Agenturleiter
  useEffect(() => {
    const loadAgenturen = async () => {
      if (isOrgLeader && user?.organization_id) {
        setAgenturenLoading(true);
        try {
          const res = await getAgenturenByOrganization(user.organization_id);
          if (res.success) {
            setAgenturen(res.agenturen || []);
          }
        } catch (e) {
          setAgenturen([]);
        } finally {
          setAgenturenLoading(false);
        }
      } else if (isAgenturLeader) {
        // Agenturleiter: Nur eigene Agentur anzeigen
        { console.log("User Data : ", user) }
        if (user?.agentur_id) {
          setAgenturenLoading(true);
          try {
            // Hole alle Agenturen der Organisation, filtere auf eigene
            const res = await getAgenturenByOrganization(user.organization_id);
            if (res.success) {
              const eigeneAgentur = (res.agenturen || []).filter(a => String(a.id) === String(user.agentur_id));
              setAgenturen(eigeneAgentur);
            } else {
              setAgenturen([]);
            }
          } catch (e) {
            setAgenturen([]);
          } finally {
            setAgenturenLoading(false);
          }
        } else {
          // Kein agentur_id vorhanden: Fehler anzeigen
          setAgenturen([]);
          setAgenturenLoading(false);
          setAgenturenFehler('Keine agentur_id im Benutzerprofil gefunden!');
        }
      }
    };
    loadAgenturen();
  }, [isOrgLeader, isAgenturLeader, user?.organization_id, user?.agentur_id]);

  const displayName = user?.full_name || user?.email || 'Benutzer';
  const showCustomerDropdown = isCallcenterLeader && !isFachberater; // Nur Callcenter Leader haben Dropdown

  // Logo-Pfad basierend auf Organisations-ID
  const getLogoPath = () => {
    if (!user?.organization_id) {
      return null;
    }
    return `/logo_${user.organization_id}.png`;
  };

  const logoPath = getLogoPath();

  // Styles
  const brandStyles = {
    fontSize: '22px',
    fontWeight: '700',
    color: '#4a6de5',
    display: 'flex',
    alignItems: 'center'
  };

  const logoStyles = {
    height: '40px',
    width: 'auto',
    maxWidth: '200px',
    objectFit: 'contain'
  };

  const linksContainerStyles = {
    display: 'flex',
    gap: '15px'
  };

  const buttonStyles = {
    background: 'none',
    color: '#4a5568',
    fontWeight: '500',
    width: 'auto',
    padding: '8px 15px',
    borderRadius: '4px',
    transition: 'all 0.2s',
    border: 'none',
    cursor: 'pointer'
  };

  const activeButtonStyles = {
    ...buttonStyles,
    background: '#ebf4ff',
    color: '#4a6de5'
  };

  const dropdownButtonStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '8px 15px',
    background: 'none',
    color: '#4a5568',
    fontWeight: '500',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'all 0.2s'
  };

  const dropdownMenuStyles = {
    position: 'absolute',
    top: '100%',
    left: '0',
    backgroundColor: 'white',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    zIndex: '1000',
    minWidth: '200px',
    marginTop: '4px'
  };

  const dropdownItemStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '8px 16px',
    textAlign: 'left',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#4a5568',
    transition: 'background-color 0.2s'
  };

  const userSectionStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    minWidth: '250px' // Mindestbreite für mehr Platz
  };

  const userInfoStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '4px'
  };

  const userNameStyles = {
    color: '#4a5568',
    fontWeight: '500',
    fontSize: '14px',
    whiteSpace: 'nowrap'
  };

  const badgeContainerStyles = {
    display: 'flex',
    gap: '4px',
    justifyContent: 'flex-end'
  };

  const badgeStyles = {
    display: 'inline-block',
    padding: '0.2rem 0.4rem',
    borderRadius: '0.25rem',
    fontSize: '0.7rem',
    fontWeight: '500'
  };

  const logoutButtonStyles = {
    background: '#f3f4f6',
    color: '#4b5563',
    border: '1px solid #d1d5db',
    padding: '8px 15px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'all 0.2s',
    whiteSpace: 'nowrap'
  };

  const handleCustomerFilterWrapper = (filter) => {
    setCustomerDropdownOpen(false);
    handleCustomerFilter(filter);
  };

  const handleTeamDashboardWrapper = () => {
    setTeamDropdownOpen(false);
    handleTeamDashboard();
  };

  return (
    <>
      {/* Brand */}
      <div style={brandStyles}>
        {logoPath && !logoError ? (
          <img
            src={logoPath}
            alt="Organisations-Logo"
            style={logoStyles}
            onError={() => setLogoError(true)}
          />
        ) : (
          <span>BUNDESENERGIE NORD</span>
        )}
      </div>

      {/* Navigation Links */}
      <div style={linksContainerStyles}>
        {/* Dashboard */}
        <a
          href="/dashboard"
          style={{
            ...(activeSection === 'dashboard' ? activeButtonStyles : buttonStyles),
            textDecoration: 'none',
            display: 'inline-block'
          }}
          onClick={(e) => {
            e.preventDefault();
            onSectionChange('dashboard');
          }}
          onMouseEnter={(e) => !activeSection === 'dashboard' && (e.target.style.background = '#f7fafc')}
          onMouseLeave={(e) => !activeSection === 'dashboard' && (e.target.style.background = 'none')}
        >
          Dashboard
        </a>

        {/* Für Fachberater: Termine und Bewertungen anzeigen */}
        {isFachberater ? (
          <>
            <a
              href="/termine"
              style={{
                ...(activeSection === 'termine' ? activeButtonStyles : buttonStyles),
                textDecoration: 'none',
                display: 'inline-block'
              }}
              onClick={(e) => {
                e.preventDefault();
                navigate('/termine');
              }}
              onMouseEnter={(e) => activeSection !== 'termine' && (e.target.style.background = '#f7fafc')}
              onMouseLeave={(e) => activeSection !== 'termine' && (e.target.style.background = 'none')}
            >
              Termine
            </a>
            <a
              href="/my-bewertungen"
              style={{
                ...(activeSection === 'my-bewertungen' ? activeButtonStyles : buttonStyles),
                textDecoration: 'none',
                display: 'inline-block'
              }}
              onClick={(e) => {
                e.preventDefault();
                navigate('/my-bewertungen');
              }}
              onMouseEnter={(e) => activeSection !== 'my-bewertungen' && (e.target.style.background = '#f7fafc')}
              onMouseLeave={(e) => activeSection !== 'my-bewertungen' && (e.target.style.background = 'none')}
            >
              Alle Bewertungen
            </a>
          </>
        ) : (
          <>
            {/* Kunden Button mit Dropdown nur für Callcenter Leader */}
            {showCustomerDropdown ? (
              <div className="customer-dropdown-container" style={{ position: 'relative', display: 'inline-block' }}>
                <button
                  style={{
                    ...dropdownButtonStyles,
                    ...(activeSection === 'callcenter-leads' ? { background: '#ebf4ff', color: '#4a6de5' } : {})
                  }}
                  onClick={() => setCustomerDropdownOpen(!customerDropdownOpen)}
                  onMouseEnter={(e) => activeSection !== 'callcenter-leads' && (e.target.style.background = '#f7fafc')}
                  onMouseLeave={(e) => activeSection !== 'callcenter-leads' && (e.target.style.background = 'none')}
                >
                  Kunden
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                      transform: customerDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.2s'
                    }}
                  >
                    <polyline points="6,9 12,15 18,9"></polyline>
                  </svg>
                </button>

                {customerDropdownOpen && (
                  <div style={dropdownMenuStyles}>
                    {/* Alle Leads */}
                    <a
                      href="/kunden"
                      style={{
                        ...dropdownItemStyles,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCustomerDropdownOpen(false);
                        navigate('/kunden');
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <span>Alle Leads</span>
                      <span style={{
                        backgroundColor: '#e2e8f0',
                        color: '#4a5568',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        padding: '1px 5px',
                        fontWeight: '600'
                      }}>
                        {leadCounts.all}
                      </span>
                    </a>

                    {/* Offene Leads */}
                    <a
                      href="/kunden-offene-leads"
                      style={{
                        ...dropdownItemStyles,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCustomerDropdownOpen(false);
                        navigate('/kunden-offene-leads');
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <span>Offene Leads</span>
                      <span style={{
                        backgroundColor: '#fefcbf',
                        color: '#d69e2e',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        padding: '1px 5px',
                        fontWeight: '600'
                      }}>
                        {leadCounts.open}
                      </span>
                    </a>

                    {/* On Hold */}
                    <a
                      href="/kunden-on-hold"
                      style={{
                        ...dropdownItemStyles,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCustomerDropdownOpen(false);
                        navigate('/kunden-on-hold');
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <span>On Hold</span>
                      <span style={{
                        backgroundColor: '#e2e8f0',
                        color: '#4a5568',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        padding: '1px 5px',
                        fontWeight: '600'
                      }}>
                        {leadCounts.onHold}
                      </span>
                    </a>

                    <a
                      href="/kunden-ohne-opt-in"
                      style={{
                        ...dropdownItemStyles,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCustomerDropdownOpen(false);
                        navigate('/kunden-ohne-opt-in');
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <span>Ohne Opt-In</span>
                      <span style={{
                        backgroundColor: '#fefcbf',
                        color: '#d69e2e',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        padding: '1px 5px',
                        fontWeight: '600'
                      }}>
                        {leadCounts.ohneOptIn}
                      </span>
                    </a>

                    {/* Termin Abgesagt */}
                    <a
                      href="/kunden-termin-abgesagt"
                      style={{
                        ...dropdownItemStyles,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCustomerDropdownOpen(false);
                        navigate('/kunden-termin-abgesagt');
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <span>Termin Abgesagt</span>
                      <span style={{
                        backgroundColor: '#fed7d7',
                        color: '#e53e3e',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        padding: '1px 5px',
                        fontWeight: '600'
                      }}>
                        {leadCounts.terminAbgesagt}
                      </span>
                    </a>

                    {/* NE Kunden */}
                    <a
                      href="/kunden-nicht-erreicht"
                      style={{
                        ...dropdownItemStyles,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCustomerDropdownOpen(false);
                        navigate('/kunden-nicht-erreicht');
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <span>NE Kunden</span>
                      <span style={{
                        backgroundColor: '#fed7d7',
                        color: '#e53e3e',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        padding: '1px 5px',
                        fontWeight: '600'
                      }}>
                        {leadCounts.neKunden}
                      </span>
                    </a>

                    {/* Später anrufen */}
                    <a
                      href="/kunden-spaeter-anrufen"
                      style={{
                        ...dropdownItemStyles,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCustomerDropdownOpen(false);
                        navigate('/kunden-spaeter-anrufen');
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <span>Später anrufen</span>
                      <span style={{
                        backgroundColor: '#c3dafe',
                        color: '#3182ce',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        padding: '1px 5px',
                        fontWeight: '600'
                      }}>
                        {leadCounts.spaeterAnrufen}
                      </span>
                    </a>

                    {/* Test Leads */}
                    <a
                      href="/kunden-test-leads"
                      style={{
                        ...dropdownItemStyles,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCustomerDropdownOpen(false);
                        navigate('/kunden-test-leads');
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <span>Test Leads</span>
                      <span style={{
                        backgroundColor: '#e9d8fd',
                        color: '#6b46c1',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        padding: '1px 5px',
                        fontWeight: '600'
                      }}>
                        {leadCounts.testLeads || 0}
                      </span>
                    </a>

                    {/* Final nicht erreicht */}
                    <a
                      href="/kunden-final-nicht-erreicht"
                      style={{
                        ...dropdownItemStyles,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCustomerDropdownOpen(false);
                        navigate('/kunden-final-nicht-erreicht');
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <span>Final nicht erreicht</span>
                      <span style={{
                        backgroundColor: '#bdbdbd',
                        color: '#212121',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        padding: '1px 5px',
                        fontWeight: '600'
                      }}>
                        {leadCounts.finalNichtErreicht}
                      </span>
                    </a>

                    {/* Final abgesagt */}
                    <a
                      href="/kunden-final-abgesagt"
                      style={{
                        ...dropdownItemStyles,
                        textDecoration: 'none',
                        display: 'block'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        setCustomerDropdownOpen(false);
                        navigate('/kunden-final-abgesagt');
                      }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                    >
                      <span>Final abgesagt</span>
                      <span style={{
                        backgroundColor: '#ff6b6b',
                        color: '#ffffff',
                        borderRadius: '8px',
                        fontSize: '0.7rem',
                        padding: '1px 5px',
                        fontWeight: '600'
                      }}>
                        {leadCounts.finalAbgesagt}
                      </span>
                    </a>
                  </div>
                )}
              </div>
            ) : !isOrgLeader && isCallcenterMitarbeiter ? (
              // Callcenter Mitarbeiter haben einfachen Kunden-Button ohne Dropdown - Nicht für OrgLeader
              <a
                href="/kunden"
                style={{
                  ...(activeSection === 'callcenter-leads' ? activeButtonStyles : buttonStyles),
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/kunden');
                }}
                onMouseEnter={(e) => activeSection !== 'callcenter-leads' && (e.target.style.background = '#f7fafc')}
                onMouseLeave={(e) => activeSection !== 'callcenter-leads' && (e.target.style.background = 'none')}
              >
                Kunden
              </a>
            ) : (
              // Normale Benutzer und OrgLeader haben normalen Kunden-Button für Leads.js
              <a
                href="/leads-normal"
                style={{
                  ...(activeSection === 'leads' ? activeButtonStyles : buttonStyles),
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/leads-normal');
                }}
                onMouseEnter={(e) => activeSection !== 'leads' && (e.target.style.background = '#f7fafc')}
                onMouseLeave={(e) => activeSection !== 'leads' && (e.target.style.background = 'none')}
              >
                Kunden
              </a>
            )}

            {/* Leads für Nicht-Callcenter und OrgLeader */}
            {!isCallcenterLeader && !isCallcenterMitarbeiter && (
              <a
                href="/leads"
                style={{
                  ...(activeSection === 'leads-overview' ? activeButtonStyles : buttonStyles),
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/leads');
                }}
                onMouseEnter={(e) => activeSection !== 'leads-overview' && (e.target.style.background = '#f7fafc')}
                onMouseLeave={(e) => activeSection !== 'leads-overview' && (e.target.style.background = 'none')}
              >
                Leads
              </a>
            )}

            {/* Termine für Callcenter Leader */}
            {isCallcenterLeader && (
              <a
                href="/termine"
                style={{
                  ...(activeSection === 'termine' ? activeButtonStyles : buttonStyles),
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/termine');
                }}
                onMouseEnter={(e) => activeSection !== 'termine' && (e.target.style.background = '#f7fafc')}
                onMouseLeave={(e) => activeSection !== 'termine' && (e.target.style.background = 'none')}
              >
                Termine
              </a>
            )}

            {/* Team Dropdown für Teamleiter in einer Agentur: Nur eigenes Team, Links wie bei Orgleiter */}
            {isTeamlead && user?.a_team_id && isAgenturLeader && (
              <div className="team-dropdown-container" style={{ position: 'relative', display: 'inline-block' }}>
                <button
                  style={{
                    ...buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  onClick={() => setTeamDropdownOpen(!teamDropdownOpen)}
                  onMouseEnter={(e) => !teamDropdownOpen && (e.target.style.background = '#f7fafc')}
                  onMouseLeave={(e) => !teamDropdownOpen && (e.target.style.background = 'none')}
                >
                  👥 Team
                  <span style={{
                    transform: teamDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s'
                  }}>
                    ▼
                  </span>
                </button>
                {teamDropdownOpen && (
                  <div style={dropdownMenuStyles}>
                    <button
                      style={dropdownItemStyles}
                      onClick={() => {
                        navigate(`/agenturen/${user.agentur_id}/teams/${user.a_team_id}/dashboard`);
                        setTeamDropdownOpen(false);
                      }}
                    >
                      📊 Team Dashboard
                    </button>
                    <button
                      style={dropdownItemStyles}
                      onClick={() => {
                        navigate(`/agenturen/${user.agentur_id}/teams/${user.a_team_id}/mitarbeiter`);
                        setTeamDropdownOpen(false);
                      }}
                    >
                      👥 Mitglieder ansehen
                    </button>
                    <button
                      style={dropdownItemStyles}
                      onClick={() => {
                        navigate(`/agenturen/${user.agentur_id}/teams/${user.a_team_id}/leads`);
                        setTeamDropdownOpen(false);
                      }}
                    >
                      📋 Team-Leads ansehen
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Standard Team Dropdown für andere Teamleiter */}
            {isTeamlead && (!user?.a_team_id || !isAgenturLeader) && (
              <div className="team-dropdown-container" style={{ position: 'relative', display: 'inline-block' }}>
                <button
                  style={{
                    ...buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  onClick={() => setTeamDropdownOpen(!teamDropdownOpen)}
                  onMouseEnter={(e) => !teamDropdownOpen && (e.target.style.background = '#f7fafc')}
                  onMouseLeave={(e) => !teamDropdownOpen && (e.target.style.background = 'none')}
                >
                  👥 Team
                  <span style={{
                    transform: teamDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s'
                  }}>
                    ▼
                  </span>
                </button>
                {teamDropdownOpen && (
                  <div style={dropdownMenuStyles}>
                    {console.log("User : ", user)}
                    {user?.agentur_id && user?.a_team_id ? (
                      <>
                        <button
                          style={dropdownItemStyles}
                          onClick={() => {
                            navigate(`/agenturen/${user.agentur_id}/teams/${user.a_team_id}/dashboard`);
                            setTeamDropdownOpen(false);
                          }}
                        >
                          📊 Team Dashboard
                        </button>
                        <button
                          style={dropdownItemStyles}
                          onClick={() => {
                            navigate(`/agenturen/${user.agentur_id}/teams/${user.a_team_id}/mitarbeiter`);
                            setTeamDropdownOpen(false);
                          }}
                        >
                          👥 Mitglieder ansehen
                        </button>
                        <button
                          style={dropdownItemStyles}
                          onClick={() => {
                            navigate(`/agenturen/${user.agentur_id}/teams/${user.a_team_id}/leads`);
                            setTeamDropdownOpen(false);
                          }}
                        >
                          📋 Team-Leads ansehen
                        </button>
                      </>
                    ) : (
                      <div style={{ padding: '8px 16px', color: 'red' }}>
                        Team- oder Agentur-ID fehlt. Bitte kontaktieren Sie den Administrator.
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Mein Team entfernt */}

            {/* Organisationen Button - Ersetzt das alte "Meine Organisation" Dropdown */}
            {(isOrgLeader || isAdmin) && (
              <div className="org-dropdown-container" style={{ position: 'relative', display: 'inline-block' }}>
                <button
                  style={{
                    ...dropdownButtonStyles,
                    ...(activeSection === 'org-dashboard' ? { background: '#ebf4ff', color: '#4a6de5' } : {})
                  }}
                  onClick={() => setOrgDropdownOpen(!orgDropdownOpen)}
                  onMouseEnter={(e) => activeSection !== 'org-dashboard' && (e.target.style.background = '#f7fafc')}
                  onMouseLeave={(e) => activeSection !== 'org-dashboard' && (e.target.style.background = 'none')}
                >
                  Organisationen
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                      transform: orgDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.2s'
                    }}
                  >
                    <polyline points="6,9 12,15 18,9"></polyline>
                  </svg>
                </button>

                {orgDropdownOpen && (
                  <div style={dropdownMenuStyles}>
                    <OrganizationsList
                      user={user}
                      navigate={navigate}
                      onClose={() => setOrgDropdownOpen(false)}
                      submenuItemStyles={dropdownItemStyles}
                      onOpenOrganizationManagement={onOpenOrganizationManagement}
                      onOpenMembersManagement={onOpenMembersManagement}
                      onViewOrganizationLeads={handleViewOrganizationLeads}
                    />
                  </div>
                )}
              </div>
            )}

            {/* Stellungnahmen - Nicht für Fachberater und nicht für Agenturleiter */}
            {(!isFachberater && !isAgenturLeader) && (
              <a
                href="/stellungnahmen"
                style={{
                  ...buttonStyles,
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/stellungnahmen');
                }}
                onMouseEnter={(e) => activeSection !== 'stellungnahmen' && (e.target.style.background = '#f7fafc')}
                onMouseLeave={(e) => activeSection !== 'stellungnahmen' && (e.target.style.background = 'none')}
              >
                Stellungnahmen
              </a>
            )}

            {isCallcenterLeader && (
              <a
                href="/callcenter-dashboard"
                style={{
                  ...(activeSection === 'callcenter-dashboard' ? activeButtonStyles : buttonStyles),
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/callcenter-dashboard');
                }}
                onMouseEnter={(e) => !activeSection === 'callcenter-dashboard' && (e.target.style.background = '#f7fafc')}
                onMouseLeave={(e) => !activeSection === 'callcenter-dashboard' && (e.target.style.background = 'none')}
              >
                📊 Callcenter Dashboard
              </a>
            )}

            {/* Termine - Nur für Orgleiter */}
            {isOrgLeader && (
              <a
                href="/termine"
                style={{
                  ...(activeSection === 'termine' ? activeButtonStyles : buttonStyles),
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/termine');
                }}
                onMouseEnter={(e) => activeSection !== 'termine' && (e.target.style.background = '#f7fafc')}
                onMouseLeave={(e) => activeSection !== 'termine' && (e.target.style.background = 'none')}
              >
                Termine
              </a>
            )}

            {/* Bestellverwaltung - Nur für Organisationsleiter */}
            {isOrgLeader && (
              <a
                href="/orders-management"
                style={{
                  ...(activeSection === 'orders-management' ? activeButtonStyles : buttonStyles),
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/orders-management');
                }}
                onMouseEnter={(e) => activeSection !== 'orders-management' && (e.target.style.background = '#f7fafc')}
                onMouseLeave={(e) => activeSection !== 'orders-management' && (e.target.style.background = 'none')}
              >
                Bestellverwaltung
              </a>
            )}

            {/* Agenturen Dropdown */}
            {isOrgLeader || isAgenturLeader && (
              <div className="agenturen-dropdown-container" style={{ position: 'relative', display: 'inline-block' }}>
                <button
                  style={dropdownButtonStyles}
                  onClick={() => {
                    setAgenturenDropdownOpen(!agenturenDropdownOpen);
                    setSelectedAgenturId(null); // Untermenü schließen, wenn Hauptmenü neu geöffnet wird
                  }}
                  onMouseEnter={(e) => !agenturenDropdownOpen && (e.target.style.background = '#f7fafc')}
                  onMouseLeave={(e) => !agenturenDropdownOpen && (e.target.style.background = 'none')}
                >
                  🏢 Agenturen verwalten
                  <span style={{
                    transform: agenturenDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s'
                  }}>
                    ▼
                  </span>
                </button>
                {agenturenDropdownOpen && (
                  <div style={dropdownMenuStyles}>
                    {agenturenFehler ? (
                      <div style={{ padding: '8px 16px', color: 'red' }}>{agenturenFehler}</div>
                    ) : agenturenLoading ? (
                      <div style={{ padding: '8px 16px', color: '#666' }}>Lade Agenturen...</div>
                    ) : agenturen.length === 0 ? (
                      <div style={{ padding: '8px 16px', color: '#666' }}>Keine Agenturen verfügbar</div>
                    ) : (
                      agenturen.map(ag => (
                        <div key={ag.id} style={{ position: 'relative' }}>
                          <button
                            style={dropdownItemStyles}
                            onClick={() => setSelectedAgenturId(selectedAgenturId === ag.id ? null : ag.id)}
                            onMouseEnter={e => e.target.style.backgroundColor = '#f7fafc'}
                            onMouseLeave={e => e.target.style.backgroundColor = 'transparent'}
                          >
                            {ag.name}
                            <span style={{ float: 'right', marginLeft: 8 }}>▶</span>
                          </button>
                          {/* Untermenü für die ausgewählte Agentur */}
                          {selectedAgenturId === ag.id && (
                            <div style={{
                              ...dropdownMenuStyles,
                              position: 'absolute',
                              left: '100%',
                              top: 0,
                              minWidth: '180px',
                              zIndex: 1100
                            }}>
                              <button
                                style={dropdownItemStyles}
                                onClick={() => {
                                  navigate(`/agentur-dashboard/${ag.id}`);
                                  setAgenturenDropdownOpen(false);
                                  setSelectedAgenturId(null);
                                }}
                              >
                                📊 Dashboard anzeigen
                              </button>
                              <button
                                style={dropdownItemStyles}
                                onClick={() => {
                                  navigate(`/agenturen/${ag.id}/mitglieder`);
                                  setAgenturenDropdownOpen(false);
                                  setSelectedAgenturId(null);
                                }}
                              >
                                👥 Mitglieder verwalten
                              </button>
                              <button
                                style={dropdownItemStyles}
                                onClick={() => {
                                  navigate(`/agenturen/${ag.id}/leads`);
                                  setAgenturenDropdownOpen(false);
                                  setSelectedAgenturId(null);
                                }}
                              >
                                📋 Alle Leads
                              </button>
                              <button
                                style={dropdownItemStyles}
                                onClick={() => {
                                  navigate(`/agenturen/${ag.id}/teams`);
                                  setAgenturenDropdownOpen(false);
                                  setSelectedAgenturId(null);
                                }}
                              >
                                👨‍👩‍👧‍👦 Meine Teams
                              </button>
                            </div>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Bestellungen - Nur für Agenturleiter */}
            {isAgenturLeader && (
              <a
                href="/orders"
                style={{
                  ...(activeSection === 'orders' ? activeButtonStyles : buttonStyles),
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/orders');
                }}
                onMouseEnter={(e) => activeSection !== 'orders' && (e.target.style.background = '#f7fafc')}
                onMouseLeave={(e) => activeSection !== 'orders' && (e.target.style.background = 'none')}
              >
                🛒 Bestellungen
              </a>
            )}

            {/* Einstellungen - Für alle Rollen */}
            <button
              style={buttonStyles}
              onClick={openSettingsPanel}
              onMouseEnter={(e) => e.target.style.background = '#f7fafc'}
              onMouseLeave={(e) => e.target.style.background = 'none'}
            >
              Einstellungen
            </button>

          </>
        )}

      </div>

      {/* User Section */}
      <div style={userSectionStyles}>
        <div style={userInfoStyles}>
          <span style={userNameStyles}>
            Hallo, {displayName}
          </span>
          <div style={badgeContainerStyles}>
            {isAdmin && <span style={{ ...badgeStyles, backgroundColor: '#fed7d7', color: '#c53030' }}>Admin</span>}
            {isTeamlead && <span style={{ ...badgeStyles, backgroundColor: '#c6f6d5', color: '#2f855a' }}>Teamleiter</span>}
            {isOrgLeader && <span style={{ ...badgeStyles, backgroundColor: '#c7d2fe', color: '#4338ca' }}>Orgleiter</span>}
            {isCallcenterLeader && <span style={{ ...badgeStyles, backgroundColor: '#fef3c7', color: '#d97706' }}>Callcenter</span>}
            {isCallcenterMitarbeiter && <span style={{ ...badgeStyles, backgroundColor: '#dbeafe', color: '#1d4ed8' }}>Callcenter</span>}
            {isFachberater && <span style={{ ...badgeStyles, backgroundColor: '#d4edda', color: '#28a745' }}>Fachberater</span>}
            {isAgenturLeader && <span style={{ ...badgeStyles, backgroundColor: '#c7d2fe', color: '#4338ca' }}>Agenturleiter</span>}
          </div>
        </div>
        {(isOrgLeader || isAgenturLeader) && (
          <NotificationBell userId={user?.id} />
        )}
        <button
          style={logoutButtonStyles}
          onClick={onLogout}
          onMouseEnter={(e) => {
            e.target.style.background = '#e5e7eb';
            e.target.style.color = '#1f2937';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = '#f3f4f6';
            e.target.style.color = '#4b5563';
          }}
        >
          Ausloggen
        </button>
      </div>
    </>
  );
}

export default DesktopNavigation;